package learning.components


import antd.tag.tag
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionEntityType
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionRelationType
import com.jingfangpai.contentEntity.model.ContentConnections
import kotlinext.js.js
import react.*
import react.dom.attrs
import react.dom.div
import react.dom.jsStyle
import react.dom.span

external interface ContentConnectionComponentProps : RProps {
    var connections :Array<ContentConnections>
    var wrapperStyle:dynamic
    var onTagClick: ((entityId: String?, entityName: String?, entityType: ContentConnectionEntityType?, relationType: ContentConnectionRelationType?, connectionId: String?) -> Unit)?
}

val ContentConnectionComponent = functionalComponent<ContentConnectionComponentProps> { props ->

    val (connections,setConnnections) = useState(props.connections)

    useEffect(props.connections) {
        setConnnections(props.connections)
    }

    div("ContentConnectionComponent") {
        attrs{
            jsStyle = props.wrapperStyle?:js{}
        }
        if(!connections.isNullOrEmpty()){
            span {
                attrs{
                    jsStyle = js{
                        marginLeft = "10px"
                    }
                }
                +"["
            }
            connections.forEach { connGroup ->
                when(connGroup.entityType){
                    ContentConnectionEntityType.SignSymptom ->
                        span { 
                            +"症状"
                            connGroup.connectedEntities?.forEach { ce ->
                                tag {
                                    attrs.color = "blue"
                                    attrs.onClick = {
                                        props.onTagClick?.invoke(ce.entityId, ce.entityName, connGroup.entityType, ce.relationType, ce.connectionId)
                                    }
                                    +"${ce.entityName?:""}${if(ContentConnectionRelationType.排斥 == ce.relationType) "(排斥)" else ""}"
                                }
                            }
                        }
                    else -> {
                        span {
                            +"${connGroup.entityType?.getLiteral()?:""}"
                            connGroup.connectedEntities?.forEach { ce ->
                                tag {
                                    attrs.color = "blue"
                                    attrs.onClick = {
                                        props.onTagClick?.invoke(ce.entityId, ce.entityName, connGroup.entityType, ce.relationType, ce.connectionId)
                                    }
                                    +"${ce.entityName?:""}${if (ContentConnectionRelationType.排斥 == ce.relationType) "(排斥)" else ""}"
                                }
                            }
                        }
                    }
                }
            }
            span {
                +"]"
            }
        }
    }
}
